import templateUrl from "emun.order/retrieve-tokenex-info.htm";
import RetrieveTokenExInfoController from "emun.order/retrieve-tokenex-info.controller";
import open from "webmodals/open";

let RetrieveTokenExInfo = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
	  controller: RetrieveTokenExInfoController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default RetrieveTokenExInfo;
